import type { DatiMisureFotovoltaicoDTO } from '@/models/dto/fotovoltaico/dati-misure-fotovoltaico-dto'
import type { PhotovoltaicReadings } from '@/models/types/photovoltaic/photovoltaic-readings'
import { mapToMisureFotovoltaicoDTO, mapToPhotovoltaicReading } from './photovoltaic-reading-mapper'

const mapToPhotovoltaicReadings = (dto: DatiMisureFotovoltaicoDTO): PhotovoltaicReadings => {
    return {
        isAggregated: dto.isAggregated,
        readings: dto.datas?.map((reading) => mapToPhotovoltaicReading(reading)) ?? [],
    }
}

const mapToDatiFotovoltaicoDTO = (readings: PhotovoltaicReadings): DatiMisureFotovoltaicoDTO => {
    return {
        isAggregated: readings.isAggregated,
        datas: readings.readings.map((reading) => mapToMisureFotovoltaicoDTO(reading)),
    }
}

export { mapToDatiFotovoltaicoDTO, mapToPhotovoltaicReadings }
